import TransferHistory from "../../../Dealer/TransferHistory/TransferHistory"
import useStore from "../../../../store"
import TransferPage from "../../../Dealer/TransferPage/TransferPage"
import { motion } from "framer-motion"
import BackButton from "../../../common/BackButton"
import TransferPageBody from "../../../Dealer/TransferPage/TransferPageBody"
import { useState } from "react"

export default function DealerTransactions() {
  const dealer = useStore((state) => state.dealer)
  const [dashboardTransferId, setDashboardTransferId] = useState(null)

  return (
    <div className="w-full">
      {dashboardTransferId ?
        <div className="overflow-x-hidden pt-2">
          <motion.div
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            transition={{ type: 'tween', duration: 0.2 }}
          >
            <BackButton onClick={() => setDashboardTransferId(null)} />
            <TransferPageBody />
          </motion.div>
        </div>
      :
        <TransferHistory dealerId={dealer.id} setDashboardTransferId={setDashboardTransferId}/>
      }
    </div>
  )
}